/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Scheduled_Sync_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update the automatic sync." |
*
* @param {Spaces_Scheduled_Sync_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_scheduled_sync_error = /** @type {((inputs?: Spaces_Scheduled_Sync_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Scheduled_Sync_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Synchronisierung konnte nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Could not update the automatic sync.")
});